import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosGet, axiosPut } from "utils/APIHelper";
import { getHltInncodes, setInitialWizardTaken } from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { OnboardingState } from "./Onboarding";

const initialState: OnboardingState = {
  onboardingResponse: {},
  isOnboardingCompleted: true,
  status: "idle",
  showOnboardingWizard: true,
  showOnboardingWizardFromLibrary: false,
  showWizardLoader: false,
  initialWizard: false
};

export const fetchOnboardingQueries = createAsyncThunk("OnboardingWizardQueries", async (data: any, thunkApi) => {
  const API_URL = `wizards/${data.wizardType}?innCode=${getHltInncodes(true)}`;
  const response: any = await axiosGet(API_URL, "recommendation");
  return response.data;
});

export const fetchOnboardingQueriesCheck = createAsyncThunk(
  "OnboardingWizardQueriesCheck",
  async (data: any, thunkApi) => {
    const API_URL = `wizards/ON_BOARDING/check`;
    const response: any = await axiosGet(API_URL, "recommendation");
    if (
      response?.response?.status >= responseTypes.internal_error &&
      response?.response?.status < responseTypes.other_error
    ) {
      return thunkApi.rejectWithValue(response.response);
    }

    return response.data;
  }
);

export const updateOnboardingQueries = createAsyncThunk("UpdateOnboardingWizard", async (data: any, thunkApi) => {
  const API_URL = `wizards/response`;
  const response: any = await axiosPut(API_URL, "recommendation", data.payload);

  if (response.response?.status === responseTypes.error) {
    return thunkApi.rejectWithValue(response.response.data);
  }
  return response.data;
});

export const OnboardingSlice = createSlice({
  name: "OnboardingQueries",
  initialState,
  reducers: {
    setShowOnboardingWizard: (state, action) => {
      state.showOnboardingWizard = action.payload;
    },
    setShowOnboardingWizardFromLibrary: (state, action) => {
      state.showOnboardingWizardFromLibrary = action.payload;
    },
    setInitialWizard: (state, action) => {
      state.initialWizard = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingQueries.pending, (state) => {
        state.showWizardLoader = true;
        state.status = "loading";
      })
      .addCase(fetchOnboardingQueries.fulfilled, (state, action) => {
        state.status = "idle";
        state.showWizardLoader = false;
        state.onboardingResponse = action.payload;
      })
      .addCase(fetchOnboardingQueries.rejected, (state) => {
        state.showWizardLoader = false;
        state.status = "failed";
      })
      .addCase(fetchOnboardingQueriesCheck.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchOnboardingQueriesCheck.fulfilled, (state, action) => {
        state.status = "idle";
        state.initialWizard = !!action.payload.createdDate;
        if (!!action.payload.createdDate) setInitialWizardTaken();
        state.isOnboardingCompleted = !!action.payload.createdDate;
      })
      .addCase(fetchOnboardingQueriesCheck.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(updateOnboardingQueries.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateOnboardingQueries.fulfilled, (state, action) => {
        state.status = "idle";
        state.isOnboardingCompleted = !!action.payload.createdDate;
      })
      .addCase(updateOnboardingQueries.rejected, (state) => {
        state.status = "failed";
      });
  }
});

export const { setShowOnboardingWizard, setShowOnboardingWizardFromLibrary, setInitialWizard } =
  OnboardingSlice.actions;

export default OnboardingSlice.reducer;
